<template>
  <div class="headerbg" :class="[{ homeheader: $route.name == 'Home' }]">
    <div class="header clearfix">
      <a class="header-logo fl" href="../home">
        <img src="../assets/img/home/head_logo.png" alt />
      </a>
      <div class="header-nav fr">
        <ul>
          <el-menu mode="horizontal">
            <el-menu-item index="0">
              <router-link to="/home">首页</router-link>
            </el-menu-item>
            <el-submenu index="1" :show-timeout="num">
              <template slot="title">
                <router-link to="/solution">解决方案</router-link>
              </template>
              <el-menu-item>
                <div class="navbox clearfix">
                  <dl class="navbox-dl">
                    <dt>智慧校园</dt>
                    <dd>
                      <h2>
                        <router-link to="/solution">学校</router-link>
                      </h2>
                      <div class="navbox-div1">
                        <router-link to="/smartschool/cardIntegration">一卡通集成系统平台</router-link>
                        <router-link to="/smartschool/faceRecognition">人脸识别安全通道闸机</router-link>
                        <router-link to="/smartschool/carRecognition">车牌自动识别系统</router-link>
                        <router-link to="/smartschool/monitoringSystem">监控系统</router-link>
                      </div>
                      <div class="navbox-div1">
                        <router-link to="/smartschool/ledScreen">LED大屏显示系统</router-link>
                        <router-link to="/smartschool/campuselEctronicfence">校园电子围栏系统</router-link>
                        <router-link to="/smartschool/intelligentLift">智能升降柱系统</router-link>
                        <router-link to="/smartschool/hdCampusTV">高清校园电视台</router-link>
                      </div>
                      <div class="navbox-div1">
                        <router-link to="/smartschool/campusRadio">校园广播系统</router-link>
                        <router-link to="/smartschool/wisdomClasscard">智慧电子班牌系统</router-link>
                        <router-link to="/smartschool/wisdomRecordbroad">智能录播系统</router-link>
                        <router-link to="/smartschool/intelligentChannel">智能通道翼闸</router-link>
                      </div>
                      <div class="navbox-div1">
                        <router-link to="/smartschool/campusfamilyPhone">校园亲情话机</router-link>
                      </div>
                    </dd>
                  </dl>
                  <dl class="navbox-dl">
                    <dt>智慧社区</dt>
                    <dd>
                      <h2>
                        <router-link to="/solution">社区</router-link>
                      </h2>
                      <div class="navbox-div1">
                        <router-link to="/smartcommunity/intelligentScreen">智慧大屏</router-link>
                        <router-link to="/smartcommunity/faceRecognition">人脸识别通道管理系统</router-link>
                      </div>
                      <div class="navbox-div1">
                        <router-link to="/smartcommunity/emotionlessParking">无人值守无感支付停车</router-link>
                        <router-link to="/smartcommunity/electricCarpile">社区电瓶车智能充电桩</router-link>
                      </div>
                      <div class="navbox-div1">
                        <router-link to="/smartcommunity/wisdomBusinessSuper">智慧商场管理系统</router-link>
                      </div>
                    </dd>
                  </dl>
                  <dl class="navbox-dl">
                    <dt>智慧工地</dt>
                    <dd>
                      <h2>
                        <router-link to="/solution">工地</router-link>
                      </h2>
                      <div class="navbox-div1">
                        <router-link to="/smartbuilding/intelligentSite">智慧工地</router-link>
                      </div>
                    </dd>
                  </dl>
                  <dl class="navbox-dl">
                    <dt>智慧景区</dt>
                    <dd>
                      <h2>
                        <router-link to="/solution">景区</router-link>
                      </h2>
                      <div class="navbox-div1">
                        <li><router-link to="/smartScenic/scenicfarecollectionSystem">景区售检票系统</router-link></li>
                        <li><router-link to="/smartScenic/scenicparkmanagerSystem">景区停车管理系统</router-link></li>
                      </div>
                      <div class="navbox-div1">
                        <li><router-link to="/smartScenic/smartsceniccosumeSystem">景区消费系统</router-link></li>
                        <li><router-link to="/smartScenic/smartnavigationSystem">智慧导览系统</router-link></li>
                      </div>
                      <div class="navbox-div1">
                        <li><router-link to="/smartScenic/promotemarketSystem">宣传营销系统</router-link></li>
                        <li><router-link to="/smartScenic/smartscenicspotdistributionSystem">智慧景区分销系统</router-link></li>
                      </div>
                      <div class="navbox-div1">
                        <li><router-link to="/smartScenic/integratedbusinessmanagerSystem">综合业务管理系统</router-link></li>
                        <li><router-link to="/smartScenic/bigdataanalyticsapplicationtypeSystem">大数据应用运行系统</router-link></li>
                      </div>
                      <div class="navbox-div1">
                        <li><router-link to="/smartScenic/videofusionSystem">视频融合系统</router-link></li>
                        <li><router-link to="/smartScenic/intelligentbroadcastSystem">智能广播系统</router-link></li>
                      </div>
                      <div class="navbox-div1">
                        <li><router-link to="/smartScenic/intelligentvideosurveillanceSystem">智能视频监控系统</router-link></li>
                        <li><router-link to="/smartScenic/environmentalmonitoringSystem">环境监测系统</router-link></li>
                      </div>
                    </dd>
                  </dl>
                </div>
              </el-menu-item>
            </el-submenu>
            <el-menu-item index="2">
              <router-link to="/case">案例中心</router-link>
            </el-menu-item>
            <el-menu-item index="3">
              <router-link to="/news">新闻动态</router-link>
            </el-menu-item>
            <el-menu-item index="4">
              <router-link to="/contact">联系我们</router-link>
            </el-menu-item>
            <el-menu-item index="5">
              <router-link to="/about">关于我们</router-link>
            </el-menu-item>
          </el-menu>
        </ul>
      </div>
      <div class="header-search fr clearfix">
        <form action method="get">
          <!-- <input type="text" name="search" /> -->
          <i @click="showSearch = !showSearch"></i>
        </form>
      </div>
      <div class="navboxbg1" v-if="showSearch" @click="hidebox">
        <div class="searchbox">
          <form action method="get">
            <input type="text" name="search" placeholder="请输入关键词" />
            <i @click="toSearch"></i>
          </form>
          <div class="clearfix"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Header',
  data() {
    return {
      showSearch: false,
      num: 1,
    };
  },
  methods: {
    toSearch() {
      this.showSearch = false;
      this.$router.push('/searchdetail');
    },
    hidebox(e) {
      if (e.target != e.currentTarget) return;
      else {
        this.showSearch = false;
      }
    },
  },
};
</script>
<style>
.header-nav .router-link-active {
  color: #0076de;
}
.headerbg {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 70px;
  line-height: 70px;
  z-index: 99;
  background-color: #fff;
}
.headerbg:hover {
  background-color: #fff;
}
.homeheader {
  position: fixed;
  width: 100%;
  background-color: rgba(255, 255, 255, 0.5);
  height: 70px;
  line-height: 70px;
  z-index: 99;
}
.header {
  max-width: 1200px;
  width: 100%;
  height: 100%;
  margin: 0 auto;
  position: relative;
  padding: 0;
  display: flex;
  justify-content: center;
}
.header-logo {
  display: inline-flex;
  position: absolute;
  left: 0;
  top: 5px;
}
.header-logo img {
  width: 84px;
  height: 60px;
}
.header-nav {
  margin-left: 140px;
  width: 800px;
}
.header-nav ul {
  display: flex;
  height: 100%;
}
.el-menu--popup .el-menu-item {
  width: 100%;
  height: 500px;
  background: #fff;
  position: fixed;
  left: 0;
  top: 68px;
  z-index: 9999;
  box-shadow: inset 0px 2px 8px 0px rgb(0 0 0 / 15%);
  padding: 30px 0;
  max-height: 100%;
}
.header-nav ul.el-menu {
  background-color: transparent;
}
.el-menu.el-menu--horizontal {
  border-bottom: none;
}
ul.el-menu--horizontal > .el-menu-item,
ul.el-menu--horizontal > .el-submenu {
  height: 70px;
  line-height: 70px;
  padding: 0 28px;
  float: left;
  text-align: center;
  font-size: 18px;
  font-weight: 400;
  color: #333;
}
ul.el-menu--horizontal > .el-submenu .el-submenu__title {
  height: 70px;
  line-height: 70px;
  color: #333;
}
.el-submenu__title > a {
  font-size: 18px;
  font-weight: 400;
}
ul.el-menu--horizontal .el-menu-item:not(.is-disabled, .noHoverbg):hover,
ul.el-menu--horizontal > .el-submenu .el-submenu__title:hover {
  background-color: #154590;
}
ul.el-menu--horizontal .el-menu-item:not(.is-disabled):hover > a,
ul.el-menu--horizontal > .el-submenu .el-submenu__title:hover > a {
  color: #fff;
}
ul.el-menu--popup-bottom-start {
  margin-top: 0;
}
.el-zoom-in-top-enter-active li.el-menu-item,
.el-zoom-in-top-leave-active li.el-menu-item {
  opacity: 0;
}
ul.el-menu--popup {
  padding: 0;
}
.navboxbg1,
.el-menu--horizontal .el-menu li.el-menu-item {
  width: 100%;
  height: 500px;
  background: #fff;
  position: fixed;
  left: 0;
  top: 68px;
  z-index: 9999;
  box-shadow: inset 0px 2px 8px 0px rgb(0 0 0 / 15%);
  padding: 30px 0;
  max-height: 100%;
  overflow: auto;
}
.el-menu--horizontal .el-menu .navbox {
  margin: 0 auto;
  width: 1200px;
  height: 500px;
  background-color: #fff;
}
.navbox dl {
  width: 600px;
  height: 300px;
  float: left;
}
.navbox dl dt {
  font-size: 24px;
  font-weight: bold;
  border-bottom: 1px solid #eee;
  padding-bottom: 20px;
}
.navbox dl dd a {
  font-size: 14px;
  display: block;
  height: 35px;
  line-height: 35px;
  margin-left: -10px;
  text-indent: 10px;
  color: #333;
}
.navbox dl dd a:hover {
  background: #f7f7f7;
}
.navbox dl dd h2 {
  margin: 20px 0 0px;
}
.navbox dl dd h2 a {
  font-size: 18px;
  color: #0076de;
  margin-left: 0px;
  text-indent: 0px;
}
.navbox-div1 {
  width: 168px;
  float: left;
}
.solution:hover .navboxbg {
  display: block;
}
.header-search {
  position: absolute;
  right: 0;
  top: 0px;
  width: 18px;
  height: 18px;
}
.header-search input {
  width: 197px;
  height: 32px;
  border: 1px solid #999999;
  border-radius: 16px;
}
.header-search i,
.navboxbg1 i {
  display: inline-block;
  width: 18px;
  height: 18px;
  background: url(../assets/img/home/head_search.png);
}
.header-search i {
  position: absolute;
  right: 10px;
  top: 26px;
}
.searchbox {
  position: absolute;
  left: 50%;
  top: 100px;
  transform: translate(-50%, 0);
}
.searchbox input {
  width: 692px;
  height: 48px;
  border: 2px solid #cccccc;
  border-radius: 10px;
  outline: none;
  color: #cccccc;
  padding-left: 22px;
}
.searchbox input::placeholder {
  font-size: 18px;
  color: #cccccc;
}
.navboxbg1 i {
  position: absolute;
  right: 10px;
  top: 26px;
}
</style>
